// 영문 소문자, 숫자, _(언더스코어 최대3개) 입력 가능 최대 15자

import { extractErrorMessage, neloLogger } from '../../utils'

/**
 * 정의 https://oss.navercorp.com/place/local/issues/16087
 * 본인뷰, 타인뷰 태그 추가 https://oss.navercorp.com/place/local/issues/19720
 */
export enum NDSTag {
  ADVERTISE = 'advertise',
  CREATE_VISIT = 'create_visit',
  CREATE_REVIEW = 'create_review',
  DISCOVERY_SELF = 'discovery_self',
  DISCOVERY_OTHER = 'discovery_othr',
  DISCOVERY = 'discovery',
  SPEND_SELF = 'spend_self',
  BUSINESS = 'business',
  REVIEWEND_SELF = 'reviewend_self',
  REVIEWEND_OTHER = 'reviewend_other',
  REVIEWFEED_SELF = 'reviewfeed_self',
  REVIEWFEED_OTHER = 'reviewfeed_other',
  THEME_SELF = 'theme_self',
  THEME_OTHER = 'theme_other',
  THEMEMAP_SELF = 'thememap_self',
  THEMEMAP_OTHER = 'thememap_other',
}

/**
 * @trigger http://ntm.navercorp.com/containers/my-place-web/triggers/custom-event-7e8ad89d-404d-4add-aa23-3f23fb8e2cb3
 * @tag http://ntm.navercorp.com/containers/my-place-web/tags/nlog-2516466e-e6ec-41d0-9144-769653b0bf35
 * @param ndsTags NDS 페이지에서 데이터를 그룹화하기 위한 Tag Code
 * @returns
 */
const sendPageViewLog = (ndsTags?: readonly NDSTag[] | null) => {
  try {
    if (!window.ntm) return

    window.ntm.push({ event: 'sendPageView', nlogEvt: { ...(ndsTags && { nds_tags: ndsTags }) } })
  } catch (error) {
    neloLogger('error', `sendPageViewLog ${extractErrorMessage(error)}`)
    return
  }
}

export default sendPageViewLog
